  let galleryOptions = {
    rewind: true,
    pagination: false,
    arrows: false,
    fixedHeight: false,
    width:'100%',
    breakpoints: {
      640: {
        padding: {
          right: '10%'
        },
        gap: 11,
        rewind: false,
        fixedHeight: 395
      }
    }
  };
  let thumbnailOptions = {
    width: '94px',
    heightRatio:1,
    isNavigation: true,
    gap: 15,
    pagination: false,
    direction: 'ttb',
    height: '740px',
    arrows: false,
    autoHeight: true,
    breakpoints: {
      1100: {
        height: '400px'
      },
      1440: {
        height: '500px'
      }
    }
  };
  let popupGalleryOptions = {
    type: 'fade',
    rewind: true,
    pagination: false,
    arrows: false
  };
  let popupThumbnailOptions = {
    isNavigation: true,
    gap: 15,
    pagination: false,
    direction: 'ttb',
    height: 700,
    autoHeight: true,
    arrows: false
  };
  document.addEventListener( 'DOMContentLoaded', function() {
    //init gallery
    var galleryMain = new Splide( '.product-main-image-splide', galleryOptions );
    var galleryThumb = new Splide( '.product-thumbnail-image-splide', thumbnailOptions );
    if(document.querySelector(".product-images-popup-main-splide") != null){
      var popupMain = new Splide('.product-images-popup-main-splide', popupGalleryOptions);
      var popupThumb = new Splide('.product-images-popup-thumbnail-splide', popupThumbnailOptions);
    }

    galleryMain.sync(galleryThumb);
    galleryMain.mount();
    galleryThumb.mount();
    if(popupMain){
      popupMain.sync(popupThumb);
      popupMain.mount();
      popupThumb.mount();
    }


    let prodImages = document.querySelector('[data-product-images]') ? JSON.parse(document.querySelector('[data-product-images]').innerHTML) : false;
    let product = document.querySelector('[data-product-variants]') ? JSON.parse(document.querySelector('[data-product-variants]').innerHTML) : false;
    //scroll gallery thumbnail on arrow click, but do not update active gallery image
    let thumbPosition = 0;
    document.querySelectorAll('.product-main-image__arrow').forEach((e)=> {
      e.addEventListener("click",function(){
        document.querySelectorAll('.product-main-image__arrow').forEach((el)=> {
          el.classList.remove("hide-v");
        });
        let thumbContainer = document.querySelector(".product-thumbnail-image-splide");
        let distance = (thumbContainer.querySelectorAll(".splide__slide")[0].getBoundingClientRect().height + 15) * 3;
        let maxDistance = thumbContainer.querySelector(".splide__list").offsetHeight - thumbContainer.querySelector(".splide__list").scrollHeight;
        if(e.classList.contains("arrow--prev")){
          thumbPosition = thumbPosition + distance > 0 ? 0 : thumbPosition + distance;
        }
        if(e.classList.contains("arrow--next")){
          thumbPosition = thumbPosition - distance < maxDistance ? maxDistance : thumbPosition - distance;
        }
        if (thumbPosition == 0) {
          document.querySelector(".arrow--prev").classList.add("hide-v")
        }
        else if(thumbPosition == maxDistance){
          document.querySelector(".arrow--next").classList.add("hide-v");
        }
          thumbContainer.querySelector(".splide__list").style.transform = `translateY(${thumbPosition}px)`;
      });
    });
  //Determine if there are alternate sizes
  let altSizes, imageList;
  const getAltSizes = (selectedColor) =>{
    for (let i = 0; i <prodImages.length; i++){
      if(prodImages[i].image_color == selectedColor){
        var image_alt = prodImages[i].image_alt;
        if(image_alt.lastIndexOf("Size:") > -1 ){
          altSizes = image_alt.substring( image_alt.lastIndexOf("Size:") + 5, image_alt.lastIndexOf("@")).split(",");
          break;
        }
      }
    }
  }
  if(document.querySelector(".product-variants .swatch-list .active") != null){
    getAltSizes(document.querySelector(".product-variants .swatch-list .active").getAttribute("data-swatch-color"));
  }
  //rebuild gallery
  const rebuildSplide = () =>{
    galleryThumb.remove('.splide__slide');
    galleryMain.remove('.splide__slide');
    if(popupMain){
      popupThumb.remove('.splide__slide');
      popupMain.remove('.splide__slide');
    }
    if(imageList.length > 3){
      document.querySelector('.product-main-image__arrow.arrow--next').classList.remove("hide");
    }
    imageList.forEach((image) => {
      var image_url = image?.image_url,
          image_alt = image?.image_alt;
        galleryThumb.add(`<li class="splide__slide"><img class="product-gallery-thumbnail-image"
          src="${image_url.replace(/(\.[\w\d_(?=\?)-]+)$/i, '_188x$1')}" alt="${image_alt}"></li>`);

        if(popupThumb){
          popupThumb.add(`<li class="splide__slide"><img src="${image_url}" alt="${image_alt}"></li>`);
        }
        if (image_alt.includes('iframe')) {
          galleryMain.add("<li class=\"splide__slide\">".concat(image_alt, "</li>"));
  
          if(popupMain){
            popupMain.add("<li class=\"splide__slide\">".concat(image_alt, "</li>"));
          }
        } else {
          galleryMain.add(`<li class="splide__slide"><img class="product-main-image" src="${image_url}" alt="${image_alt}"></li>`);

          if(popupMain){
            popupMain.add(`<li class="splide__slide"><img src="${image_url}" alt="${image_alt}"></li>`);
          }
        }
    });
  }
  const buildImageList = (selectedColor, selectedSize) =>{
    getAltSizes(selectedColor);
    let filterImages = prodImages.filter(function(image){
      if(image.image_alt.includes("iframe"))return true;
      return image.image_color == selectedColor;
    });
    let altSize = filterImages.some(i => i.image_alt.includes('Size:'));
    imageList = filterImages.filter(function(image){
      if(image.image_alt.includes("iframe"))return true;

      if(altSizes && altSizes.length > 0 && altSize){
        if(altSizes.includes(selectedSize)){
          return image.image_color == selectedColor && image.image_alt.indexOf("Size:") > -1;
        }else{
          return image.image_color == selectedColor && image.image_alt.indexOf("Size:") < 0;
        }
      }else{
        return true;
      }
    });
    rebuildSplide();
  }
  document.querySelectorAll(".size-btn").forEach((e)=>{
    e.addEventListener("click", (el)=>{
      let container = el.target.closest(".product-variants");
      container.querySelectorAll(".size-btn").forEach((btn)=>{
        btn.classList.remove("active");
      });
      el.target.classList.add("active");
      if(el.target.closest(".product-kit-form") == null){
        let selectedColor = document.querySelector(".product-variants .swatch-list .active").getAttribute("data-swatch-color"),
            selectedSize = document.querySelector(".product-variants .size-btn.active").getAttribute("data-size-value");
        buildImageList(selectedColor, selectedSize);
      }
    });
  });
  //rebuild gallery on swatch or size button click
  document.querySelectorAll('.product-variants').forEach((el)=>{
    el.addEventListener("click",function(e){
      if (e.target.closest(".color-btn:not(.swatch-btn-kit)")){
        let index = parseInt(e.target.closest(".color-btn").getAttribute('data-index'));
        document.querySelectorAll("#variant-swatch-container .color-btn").forEach((e) =>{
          e.classList.remove("active");
        })
        e.target.closest(".color-btn").classList.add("active");
        //reset thumbnail gallery
         document.querySelector(".product-thumbnail-image-splide .splide__list").style.transform = "translateY(0)";
        if (document.querySelector(".product-variants .swatch-list .color-btn.active") != null){
          prodImages = [];
          let selectedColor = document.querySelector(".product-variants .swatch-list .active").getAttribute("data-swatch-color"),
              selectedSize = document.querySelector(".product-variants .size-btn.active").getAttribute("data-size-value");
          window.varData[index].node.media.edges.forEach((e)=>{
            let imgData = {image_alt: e.node.alt, image_color: selectedColor, image_url: e.node.previewImage.url}
            prodImages.push(imgData)
          })
          buildImageList(selectedColor, selectedSize);
          document.querySelector(".product-variants .size-btn.active").click();
        }
      }
    });
  });
    //open zoomed-in image on click
      document.getElementById("hero-images-featured-interior").addEventListener("click", (e)=>{
        if (e.target.closest(".product-main-image")){
          if (popupMain) {
            popupMain.go(galleryMain.index);
          }
          document.querySelector("html").classList.add('product_images_popup_active');
        }
      });

  });